import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3003/api';
const TOKEN_KEY = 'r360_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Instância única com token injetado e tratamento global de 401.
const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token ausente/expirado/inválido: limpa e sinaliza o App (volta pro login).
      clearToken();
      window.dispatchEvent(new Event('r360-unauthorized'));
    }
    return Promise.reject(error);
  }
);

export const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  if (response.data && response.data.token) {
    setToken(response.data.token);
  }
  return response.data; // { token, user }
};

export const getMe = async () => {
  const response = await api.get('/auth/me');
  return response.data.user;
};

export const logout = () => {
  clearToken();
};

export const getAccounts = async () => {
  const response = await api.get('/accounts');
  return response.data;
};

export const getInsights = async (accountId, period = 'last_30d') => {
  const response = await api.get('/insights', { params: { accountId, period } });
  return response.data;
};

export const getCampaigns = async (accountId) => {
  const response = await api.get('/campaigns', { params: { accountId } });
  return response.data;
};

export const getAccountInfo = async (accountId) => {
  const response = await api.get('/account', { params: { accountId } });
  return response.data;
};

export const clearCache = async () => {
  const response = await api.post('/cache/clear');
  return response.data;
};

export default api;
